/* eslint-disable max-len */

import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const TemplateGalleryLayoutIcon: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_322_9438)">
      <path
        d="M13.3332 0H1.3332C0.600391 0 0 0.6 0 1.33359V30.6668C0 31.3996 0.600391 32 1.3332 32H13.3332C14.0664 32 14.6668 31.3996 14.6668 30.6668V1.33359C14.6668 0.6 14.0664 0 13.3332 0ZM12 29.3332H2.6668V2.66641H12V29.3332Z"
        fill="currentColor"
      />
      <path
        d="M30.6669 0H18.6668C17.9336 0 17.3333 0.6 17.3333 1.33359V13.3336C17.3333 14.0664 17.9336 14.6664 18.6668 14.6664H30.6669C31.3997 14.6664 32.0001 14.0664 32.0001 13.3336V1.33359C32.0001 0.6 31.3997 0 30.6669 0ZM29.3333 12H20.0001V2.66641H29.3333V12Z"
        fill="currentColor"
      />
      <path
        d="M30.6669 17.3336H18.6668C17.9336 17.3336 17.3333 17.9336 17.3333 18.6664V30.6668C17.3333 31.3996 17.9336 32 18.6668 32H30.6669C31.3997 32 32.0001 31.3996 32.0001 30.6668V18.6664C32.0001 17.9336 31.3997 17.3336 30.6669 17.3336ZM29.3333 29.3332H20.0001V20H29.3333V29.3332Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_322_9438">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
